import { Edit3, Trash2 } from "lucide-react";
import {
  CertificationDataTable,
  CertificationIconButton,
  type CertificationTableColumn,
} from "../../ui";
import type { ManualSistemaIntegradoControlModificacion } from "../types/manual-sistema-integrado";

type Props = {
  rows: ManualSistemaIntegradoControlModificacion[];
  loading: boolean;
  error: string | null;
  canManage: boolean;
  onRetry: () => void;
  onCreate: () => void;
  onEdit: (row: ManualSistemaIntegradoControlModificacion) => void;
  onDelete: (row: ManualSistemaIntegradoControlModificacion) => void;
};

export function ManualSistemaIntegradoControlDocumentalPanel({
  rows,
  loading,
  error,
  canManage,
  onRetry,
  onCreate,
  onEdit,
  onDelete,
}: Props) {
  const columns: CertificationTableColumn<ManualSistemaIntegradoControlModificacion>[] = [
    ...(canManage
      ? [{
          key: "acciones",
          header: "Acciones",
          className: "manual-si-actions-column",
          scrollable: false,
          render: (row: ManualSistemaIntegradoControlModificacion) => (
            <div className="manual-si-shared-actions">
              <CertificationIconButton
                label="Editar modificación"
                icon={<Edit3 size={15} />}
                onClick={() => onEdit(row)}
              />
              <CertificationIconButton
                label="Eliminar modificación"
                icon={<Trash2 size={15} />}
                danger
                onClick={() => onDelete(row)}
              />
            </div>
          ),
        }]
      : []),
    {
      key: "fecha",
      header: "Fecha",
      className: "manual-si-date-column",
      scrollable: false,
      render: (row) => row.fecha,
    },
    {
      key: "modificaciones",
      header: "Modificaciones realizadas",
      render: (row) => row.modificaciones_realizadas,
    },
    {
      key: "usuario",
      header: "Usuario",
      scrollable: false,
      render: (row) => row.usuario_modificacion_nombre ?? "—",
    },
  ];

  return (
    <CertificationDataTable
      title="Control documental"
      eyebrow="Historial del documento"
      countLabel={`${rows.length} registros`}
      rows={rows}
      columns={columns}
      getRowKey={(row) => row.id}
      loading={loading}
      error={error}
      emptyTitle="No hay modificaciones registradas"
      emptyDescription="La primera sustitución del manual creará automáticamente un registro."
      createLabel={canManage ? "Nueva modificación" : undefined}
      onCreate={canManage ? onCreate : undefined}
      onRetry={onRetry}
      pageSize={25}
      tableClassName="manual-si-control-table"
    />
  );
}
